import React, { Component } from 'react'

const API_KEY = "AIzaSyAYx_2_CryKvGbeC8adaGwnI2nuWER62Fo";

export default class VideoRank extends Component {


  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 4,
      toSearchForID: "",
      videoFound: false
    };

    this.fetchDataWithInput = this.fetchDataWithInput.bind(this);
    this.submitInput = this.submitInput.bind(this);
    this.extractVideoIDFromYTUrl = this.extractVideoIDFromYTUrl.bind(this);
    this.displayFoundDisplay = this.displayFoundDisplay.bind(this);
    
  }

  componentDidMount() {

  }

  resetState() {
    this.setState({
      data: [],
      pages: 4,
      toSearchForID: "",
      videoFound: false
    })
  
  }

  extractVideoIDFromYTUrl(YTUrl){
   
     
    var video_id = YTUrl.split('v=')[1];
    if(video_id)
      {
    var ampersandPosition = video_id.indexOf('&');
    if(ampersandPosition != -1) {
      video_id = video_id.substring(0, ampersandPosition);
    }
      }
    
    return video_id;

  }

  fetchDataWithInput(videoID, searchTerm, nextPageTokenToPass) {


    if(nextPageTokenToPass && this.state.videoFound == false)
    {
     

      fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&order=relevance&type=video&q=${searchTerm}&pageToken=${nextPageTokenToPass}&key=${API_KEY}`)
    .then((response) => {
      return response.json();
    })
    .then((data) => {

      console.log(data);

      let newPages = this.state.pages - 1;
      let currentData = this.state.data;
      let newData = data.items;
      let searchVideoFound = false;

      if(this.searchDataForID(videoID, data.items))
      {
        data.nextPageToken = "";
        searchVideoFound = true;
      
      }
      currentData.push(...newData)
      console.log("current date count is: ")
      console.log(currentData.length);
      
      this.setState({
        data : currentData,
        pages : newPages,
        toSearchForID: videoID,
        videoFound: searchVideoFound
      })




      if(data.nextPageToken && this.state.pages > 0 &&  this.state.videoFound == false)
      {
        this.fetchDataWithInput(videoID, searchTerm, data.nextPageToken)
      }


      console.log( this.state.data);

    })
    }
    else
    {
    fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&order=relevance&type=video&q=${searchTerm}&key=${API_KEY}`)
    .then((response) => {
      return response.json();
    })
    .then((data) => {

      console.log(data);
     

      let searchVideoFound = false;
      if(this.searchDataForID(videoID, data.items))
      {
        
        data.nextPageToken = "";
        searchVideoFound = true;
      
      };

      let newPages = this.state.pages - 1;
      this.setState({
        data : data.items,
        pages : newPages,
        toSearchForID : videoID,
        videoFound : searchVideoFound
        
      })

      if(data.nextPageToken &&  this.state.pages !== 0)
      {
        this.fetchDataWithInput(videoID, searchTerm, data.nextPageToken)
        console.log("IM GOING TO GET THE NEXT PAGE")
      }


      console.log( this.state.data);

    })
  }
  }



  searchDataForID(videoID, dataToSearch)
      {
        console.log("data to search length!!!: " + dataToSearch.length);
        for(let i = 0; i < dataToSearch.length; i++)
        {

          let item = dataToSearch[i];
          console.log("videoID is: "  + videoID);
          console.log("item.id.videoId is: "  );
        console.log(item.id.videoId);
         
          if(item.id.videoId === videoID)
          {
            console.log("**********!!!!!!!!!!!!video found!!!!!!!!!!!!!*********");
            return true;
          }
          else
          {
            console.log("video not found");
          }

        }

        return false;

      }

      displayFoundDisplay(i) {
        document.getElementById("rank_number").innerHTML = `Rank ${i + 1}`
        document.getElementById("found_setence").innerHTML = ""
        

      }

      displayClear() {
        document.getElementById("rank_number").innerHTML = ""
        document.getElementById("found_setence").innerHTML = ""
      }

      displayNotFoundDisplay() {
        
        if (this.state.videoFound == false) {
          document.getElementById("found_setence").innerHTML = "Video not found in the top 100";   
        }
       else
       document.getElementById("found_setence").innerHTML = "";  
        

      }

  submitInput(event) {

    this.displayClear();
    this.resetState();

    let videoLink = document.getElementById("video_link").value;
            console.log(videoLink);

    let searchTerm = document.getElementById("search_term").value;
            console.log(searchTerm);

            event.preventDefault();


        let videoID =  this.extractVideoIDFromYTUrl(videoLink);


            if(videoID && searchTerm)
            {
                console.log("will fetch");

                this.fetchDataWithInput(videoID, searchTerm, "");
            }
            else {
                alert("Please enter a valid YouTube video link and search term");
                console.log("will do nothing");
            }


  }
    render() {
//         return (
//             <div>
//                 <form action="/action_page.php">
//   <label for="fname">Video Link:</label><br/>
//   <input type="text" id="fname" name="fname" /><br/>
//   <label for="lname">Search Term:</label><br/>
//   <input type="text" id="lname" name="lname" /><br/><br/>
//   <input type="submit" value="Submit"/>
// </form> 
// <br/><br/>
return (

              
               

<div > 

<form onSubmit={this.submitInput}>
  <label for="fname">Enter the url of the YouTube video:</label><br/>
  <input type="text" placeholder="YouTube Video URL" id="video_link" name="fname" /><br/>
   <label for="lname">Enter the search term:</label><br/> 
  <input type="text" placeholder=" Search Term" id="search_term" name="lname" /><br/><br/>
  <input type="submit" value="Submit"/>
</form> 
<br/><br/>

<b><h2 style = {{color:"lightgreen",fontSize: "50px" }} id ="rank_number"></h2></b>
<b><h2 style = {{color:"pink"}} id ="found_setence"></h2></b>

    {

    this.state.data.map((videoItem, i) => {

      if(videoItem.id.videoId === this.state.toSearchForID)
      {
        this.displayFoundDisplay(i)
      return <div > <h3 style={{color:"lightgreen"}}>{
        
        
      

        (i + 1) + ". " + videoItem.snippet.title
 
 
         
         
       }</h3>
       <br/> 
       
       <br/><br/> 
       </div>
      
      }
      else{
        this.displayNotFoundDisplay();
      return <div > {
        

        (i + 1) + ". " + videoItem.snippet.title
 
          
       }
       <br/> 
       
       <br/><br/> 
       </div>
      } } )


    
      


  } 
  </div>

)


                
//             </div>
//         )
    }
}
